import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

type ResponseData = {
  message?: string
  created_count?: number
}

export default class extends Controller<HTMLFormElement> {
  declare readonly element: HTMLFormElement

  async submit(event: Event) {
    event.preventDefault()

    const submitter = (event as SubmitEvent).submitter as HTMLButtonElement | null
    submitter?.setAttribute("disabled", "disabled")

    try {
      const response = await fetch(this.element.action, {
        method: this.element.method || "post",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": this.csrfToken,
        },
        body: new FormData(this.element),
      })

      const data: ResponseData = await response.json().catch(() => ({}))

      if (response.ok) {
        this.element.reset()
        this.closeModal()
        this.showFlash(data.message)
      } else {
        this.showFlash(data.message, "danger")
      }
    } catch (_error) {
      this.showFlash(undefined, "danger")
    } finally {
      submitter?.removeAttribute("disabled")
    }
  }

  private get csrfToken(): string {
    return (
      (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content || ""
    )
  }

  private closeModal() {
    const modalElement = this.element.closest(".modal")
    if (!modalElement) return

    const modal = Modal.getOrCreateInstance(modalElement)
    modal.hide()
  }

  private showFlash(message?: string, variant: "success" | "danger" = "success") {
    const container = document.getElementById("blank-pages-flash")
    if (!container) return

    const text =
      message ||
      (variant === "success"
        ? "Blank pages created successfully."
        : "Something went wrong while creating blank pages.")

    const alert = document.createElement("div")
    alert.className = `mb-3 alert alert-${variant} alert-dismissible fade show`
    alert.setAttribute("role", "alert")
    alert.innerHTML = `
      ${text}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `

    container.innerHTML = ""
    container.appendChild(alert)
  }
}
